import { ConfigReader } from './ConfigReader';
export { Stage } from './ApplicationConfig';
export { ConfigReader } from './ConfigReader';

// Helper function to quickly get the config
export const getConfig = () => ConfigReader.getInstance().getConfig();
